import { useContext } from 'react';

import { ConsentStore } from '../containers/consent';
import ConsentContext from '../containers/consent/context';

const useConsent = () => useContext(ConsentContext) as ConsentStore;

export default useConsent;
